/* v8 ignore next */

import type { Credentials as STSCredentials } from "@aws-sdk/client-sts";
import { AssumeRoleCommand, STSClient } from "@aws-sdk/client-sts";

import { APPENV } from "../utils/app.environment";

export async function assumeInvocationRole(
    region: string,
    accessKeyId: string,
    secretAccessKey: string,
    sessionToken: string,
    apiInvocationRoleArn: string,
): Promise<STSCredentials> {
    if (APPENV.mock_server) {
        return {
            AccessKeyId: "",
            SecretAccessKey: "",
            SessionToken: "",
            Expiration: new Date(),
        };
    }
    const stsClient = new STSClient({
        region,
        credentials: {
            accessKeyId,
            secretAccessKey,
            sessionToken,
        },
    });

    try {
        const command = new AssumeRoleCommand({
            RoleArn: apiInvocationRoleArn,
            RoleSessionName: "AssumedRole1",
            DurationSeconds: 900,
        });
        const { Credentials } = await stsClient.send(command);

        if (!Credentials) {
            throw new Error();
        }
        return Credentials;
    } catch (err) {
        console.error("Failed to assume invocation role", err);
        throw err;
    }
}
